module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAHNJREFUWEft1TERgDAQRNF/DrADDRJItKADLQkSaMAODsLQpIA6HMVGwO3Ou8mc4fzMOR8VkIAEJCABCVSBEEJnZgswAVujIzUCayllzjmfd0YtEGPcgb5R8HPskVIa/lXAfQUf0b9i9A0lIAEJSEAC7gIXSGAeIUv5pIsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/reduce.png
// module id = AlPP
// module chunks = 1